import { FALLBACK_ROUTE_NAME } from './index.js'

/**
 * Navigate to redirectUri after auth. Uses Vue Router when the target is an in-app route, otherwise full page redirect.
 * @param {import('vue-router').Router} router
 * @param {string} redirectUri - path (e.g. /checkout/v2) or full URL
 * @returns {Promise<void>}
 */
export async function redirectAfterAuth(router, redirectUri) {
  const raw = (redirectUri || '/').trim()
  if (!raw || raw === '/') {
    await router.push('/')
    return
  }

  const isAbsoluteUrl = /^https?:\/\//i.test(raw)
  if (isAbsoluteUrl) {
    try {
      const url = new URL(raw)
      if (url.origin !== globalThis.location.origin) {
        globalThis.location.href = raw
        return
      }
      // Same origin: use pathname + search + hash
      const path = url.pathname + url.search + url.hash
      const resolved = router.resolve(path)
      const isKnownRoute =
        resolved.matched.length > 0 &&
        resolved.matched.at(-1).name !== FALLBACK_ROUTE_NAME
      if (isKnownRoute) {
        await router.push(resolved)
      } else {
        globalThis.location.href = path
      }
    } catch {
      globalThis.location.href = raw
    }
    return
  }

  // Relative path (possibly with query/hash)
  const path = raw.startsWith('/') ? raw : `/${raw}`
  const resolved = router.resolve(path)
  const isKnownRoute =
    resolved.matched.length > 0 &&
    resolved.matched.at(-1).name !== FALLBACK_ROUTE_NAME
  if (isKnownRoute) {
    await router.push(resolved)
  } else {
    globalThis.location.href = path
  }
}
